import LniJanitorialCalculations from '@gov.wa.lni/application.janitorial-workload-calculator/source/components/lni-janitorial-calculations';
import LniJanitorialJobPlan from '@gov.wa.lni/application.janitorial-workload-calculator/source/components/lni-janitorial-job-plan';
import LniJanitorialJobPlanTable from '@gov.wa.lni/application.janitorial-workload-calculator/source/components/shared/lni-janitorial-job-plan-table';
import LniJanitorialShiftDiscomfort from '@gov.wa.lni/application.janitorial-workload-calculator/source/components/lni-janitorial-shift-discomfort';

export default [
    LniJanitorialCalculations,
    LniJanitorialJobPlan,
    LniJanitorialJobPlanTable,
    LniJanitorialShiftDiscomfort,
];